import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListComponent } from './list/list.component';
import { PermissionGuard } from 'app/shared/auth/auth-guard.service';
import { NewTrackerComponent } from './new-tracker/new-tracker.component';

const routes: Routes = [
  { 
    path:'list',component:ListComponent,
    
  },
  { 
    path:'DMS-and-Camapaign',component:NewTrackerComponent,
     
  },
  { 
    path:'Digital-Assets',component:NewTrackerComponent,
     
  },
  { 
    path:'Management-List',component:NewTrackerComponent,
     
  },
  { 
    path:'Meander-Training',component:NewTrackerComponent,
     
  },
  { 
    path:'OutSourcing-Farming',component:NewTrackerComponent,
     
  },
  { 
    path:'OutSourcing-Hunting',component:NewTrackerComponent,
     
  },
  { 
    path:'LMS-Content',component:NewTrackerComponent,
     
  }
 
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TrackerRoutingModule { }
